import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Stack,
} from "@mui/material";
import { BsPencilSquare } from "react-icons/bs";
import {
  GetAllAdminDetails,
  GetAnalyticsbyType,
  getcandidateDetails,
  getCandidateLead,
} from "../../../../apiServices";
import { useSelector } from "react-redux";
import { AiOutlineClose } from "react-icons/ai";
import style from "../../../AdminDetails/ConfigarationTablesCrud/JobRoleDetails/jobRolesTable.module.scss";
import interviewStyle from "../../../Candidate/Candidate interview schedule list/candidateInterviewSchedule.module.scss";
import { useDispatch } from "react-redux";
import {
  AdminAnalyticsActions,
  commonPopupActions,
} from "../../../../redux-store/store";
import { dateFormateDD, getDateOnly, textTruncate } from "../../../../utility";
import { useFetcher } from "react-router-dom";
import AdminTableFilter from "./AdminTableFilter";
function RecentActivity({ data }) {
  const date = {
    rescheduledDateTime: data.rescheduled_dt,
    joinedOn: data.joined_on,
    selectedOn: data.selected_on,
    notSelectedOn: data.not_selected_on,
    offerRejectedOn: data.offer_rejected_on,
    notAttendedOn: data.not_attended_on,
    attendedOn: data.attended_on,
    leftTheCompanyAt: data.left_the_company_at,
    awaitingOn: data.awaiting_on,
    willJoiningOn: data.will_joining_on,
    callNotAttendOn: data.call_not_attend_on,
    notInterestedOn: data.not_interested_on,
  };
  if (date.rescheduledDateTime) {
    date.rescheduledDateTime = date.rescheduledDateTime
      .replace("T", " ")
      .replace(".000+0000", "");
  }
  let mostRecentDate = null;
  let mostRecentKey = null;

  for (const key in date) {
    const dateStr = date[key];
    if (dateStr && dateStr.includes("-")) {
      const currentDate = new Date(dateStr);

      if (!mostRecentDate || currentDate > mostRecentDate) {
        mostRecentDate = currentDate;
        mostRecentKey = key;
        // console.log(mostRecentKey);
        // console.log(mostRecentDate);
      }
    }
  }

  if (mostRecentKey) {
    if (mostRecentKey === "selectedOn") {
      return <div className={`${interviewStyle.Selected}`}>Selected</div>;
    } else if (mostRecentKey === "notSelectedOn") {
      return (
        <div className={`${interviewStyle.Notselected}`}>Not Selected</div>
      );
    } else if (mostRecentKey === "notAttendedOn") {
      return (
        <div className={`${interviewStyle.NotAttended}`}>Not Attended</div>
      );
    } else if (mostRecentKey === "offerRejectedOn") {
      return (
        <div className={`${interviewStyle.rejected_label}`}>Offer Rejected</div>
      );
    } else if (mostRecentKey === "joinedOn") {
      return <div className={`${interviewStyle.joined}`}>Joined</div>;
    } else if (mostRecentKey === "rescheduledDateTime") {
      return (
        <div className={`${interviewStyle.rescheduledChips}`}>Rescheduled</div>
      );
    } else if (mostRecentKey === "attendedOn") {
      return <div className={`${interviewStyle.Attended}`}>Attending</div>;
    } else if (mostRecentKey === "leftTheCompanyAt") {
      return (
        <div className={`${interviewStyle.leftCompany}`}>Left company</div>
      );
    } else if (mostRecentKey === "willJoiningOn") {
      return <div className={`${interviewStyle.willJoining}`}>Will Join</div>;
    } else if (mostRecentKey === "awaitingOn") {
      return <div className={`${interviewStyle.Awaitingchips}`}>Awaiting</div>;
    } else if (mostRecentKey === "callNotAttendOn") {
      return (
        <div className={`${interviewStyle.callNotAttend}`}>
          Call Not Attended
        </div>
      );
    } else if (mostRecentKey === "notInterestedOn") {
      return (
        <div className={`${interviewStyle.notInterested}`}>Not Interested</div>
      );
    }
  }

  return "";
}
function AdminTableView({ onclose }) {
  const adminAnalyticsFilter = useSelector(
    (state) => state.AdminAnalytics.typeAnalyticsFilter
  );
  const adminAnalyticsFilterType = useSelector(
    (state) => state.AdminAnalytics.typeAnalyticsFilter.type
  );
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID == 1;
  const [analyticsData, setAnalyticsData] = useState([]);
  const [data, setData] = useState();
  const [adminList, setAdminList] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const Dispatch = useDispatch();

  const handleCandidateDetails = async (candidateId, type) => {
    let data;
    if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateId);
    } else if (type === "CandidateLead") {
      data = await getCandidateLead(candidateId);
    }

    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateId,
        type: type,
        data: data,
      })
    );
  };
  useEffect(() => {
    // console.log(adminAnalyticsFilter, "good");
  }, [adminAnalyticsFilter]);
  useEffect(() => {
    GetAnalyticsbyType(adminAnalyticsFilter)
      .then((data) => {
        setAnalyticsData(data?.results || []);
        setTotalPages(data?.totalPages || 1);
        setcurrentPage(data?.currentPage || 0);
        setTotalRecords(data?.totalRecords || 0);
      })
      .catch(() => setAnalyticsData([]));
    GetAllAdminDetails()
      .then((admins) => {
        const filtered = admins.filter(
          (admin) => !admin.Deactived && admin.Module !== "Developer"
        );
        setAdminList(filtered);
      })
      .catch(() => alert("Something went wrong"));
  }, [adminAnalyticsFilter]);

  const getAdminUsername = (adminId) => {
    if (!Array.isArray(adminList)) return "Taizo";
    const admin = adminList.find((a) => a.id === adminId);
    return admin?.userName || "Taizo";
  };

  function candidatePagination(event, page) {
    const currentPage = page - 1;

    Dispatch(AdminAnalyticsActions.settypeAnalyticsPage(currentPage));
  }
  const filterTypeLabels = {
    interviewScheduledByAdmin: "Interview Scheduled",
    interviews: "Interviews",
    interviewAttended: "Interview Attended",
    selected: "Selected",
    joined: "Joined",
    leftCompany: "Left Company",
    registeredCount: "Registered",
    leadNotRegistredCount: "Leads Not Registered",
    leadRegisteredCount: "Leads Registered",
    totalLead: "Total Leads",
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div>
          <b>{filterTypeLabels[adminAnalyticsFilterType] || "Unknown Type"}</b>{" "}
          ({totalRecords})
        </div>
        <div className="d-flex align-items-center  gap-2">
          <div className="">
            <AdminTableFilter />
          </div>

          <div onClick={() => onclose()} className="btn btn-danger ">
            <AiOutlineClose />
          </div>
        </div>
      </div>
      <TableContainer style={{ height: "64vh", overflowY: "auto" }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {[
                "Candidate Name",
                "Mobile Number",
                "Job Category",
                "Interview Date",
                "Company Name",
                ...(isSuperAdmin ? ["Recruiter Name"] : []),
                ...(adminAnalyticsFilterType === "interviews"
                  ? []
                  : adminAnalyticsFilterType === "interviewAttended"
                  ? ["Attended On"]
                  : adminAnalyticsFilterType === "selected"
                  ? ["Selected On"]
                  : adminAnalyticsFilterType === "joined"
                  ? ["Joined On"]
                  : ["Created On"]),
                "Current Status",
              ].map((title, i) => (
                <TableCell
                  key={i}
                  sx={{ backgroundColor: "#169c50", color: "#fff" }}
                >
                  <strong>{title}</strong>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {analyticsData.length > 0 ? (
              analyticsData.map((row, index) => (
                <TableRow
                  key={row.id}
                  className={style["table-row"]}
                  onClick={() => setData(row)}
                >
                  {/* <TableCell sx={{ padding: "10px 12px" }}>
                    {(mothlyTargetFilter.page - 1) * 10 + index + 1}
                  </TableCell> */}
                  <TableCell
                    onClick={() => {
                      handleCandidateDetails(row.can_id, "RegisterCandidate");
                    }}
                    style={{ cursor: "pointer" }}
                    className="text-primary "
                    title={row.first_name + " " + row.last_name}
                  >
                    {row.first_name != null
                      ? textTruncate(row.first_name, 15) +
                        (row.last_name != null ? " " + row.last_name : "")
                      : "No Name"}
                  </TableCell>
                  <TableCell>{row.mobile_number}</TableCell>
                  <TableCell>
                    {row.job_category != null
                      ? textTruncate(row.job_category, 15)
                      : "-"}
                    {/* {row.job_category} */}
                  </TableCell>
                  <TableCell>{dateFormateDD(row.interview_date)}</TableCell>
                  <TableCell>
                    {row.company_name != null
                      ? textTruncate(row.company_name, 15)
                      : "-"}
                  </TableCell>
                  {isSuperAdmin && (
                    <TableCell>{getAdminUsername(row.admin_id)}</TableCell>
                  )}
                  {adminAnalyticsFilterType !== "interviews" && (
                    <TableCell>
                      {/* {dateFormateDD(row.interview_scheduled_dt)} */}
                      {adminAnalyticsFilterType === "interviewAttended"
                        ? getDateOnly(row.attended_on)
                        : adminAnalyticsFilterType == "selected"
                        ? getDateOnly(row.attended_on)
                        : adminAnalyticsFilterType == "joined"
                        ? getDateOnly(row.joined_on)
                        : getDateOnly(row.created_time)}
                    </TableCell>
                  )}
                  <TableCell>
                    <RecentActivity data={row} />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={8}
                  align="center"
                  sx={{
                    height: "60vh",
                    verticalAlign: "middle",
                    fontWeight: 500,
                    color: "#666",
                  }}
                >
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <div
      // style={{
      //   position: "fixed",
      //   bottom: 0,
      //   left: 0,
      //   width: "100%",
      //   backgroundColor: "#fff",
      //   padding: "10px 0",
      //   boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
      //   zIndex: 10,
      // }}
      >
        <Stack direction="row" justifyContent="center">
          <Pagination
            // count={10}
            shape="rounded"
            siblingCount={1}
            boundaryCount={1}
            count={totalPages}
            // page={currentPage}
            // variant="outlined"
            color="success"
            onChange={candidatePagination}
          />
        </Stack>
      </div>
    </>
  );
}

export default AdminTableView;
